import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import Lessons from './Lessons';
import Activities from './Activities';
import { useGlobalContext } from '../context/GlobalContext';

import { Banner, Hero } from '../components';

const Home = () => {
  const { user, isAdmin } = useGlobalContext();
  return (
    <>
      {user && isAdmin && <Navigate to='/' />}

      <Hero hero='defaultHero'>
        <Banner title='Home' subtitle='Family Acro Yoga'>
          <Link to='/lessen' className='btn-primary'>
            Alle lessen
          </Link>
        </Banner>
      </Hero>
      <Activities amount={10} />
      <Lessons amount={10} />
    </>
  );
};

export default Home;
